"use client";

import './mobile-dialog.css';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import FocusLock from 'react-focus-lock';
import styles from './mobile-dialog.module.scss.js';
import { Portal } from '../../portal/portal/index.js';
import OpenDialog from './utils/screen-reader-open-dialog.js';
import CloseDialog from './utils/screen-reader-close-dialog.js';

const MobileDialog = ({ open, surface = 'lightPrimary', colorMode = 'light', closeButtonText, title, body, isAndroidDevice, onClick, onTouchEnd, onTouchMove, onTouchStart, dialogId, unmounting, }) => {
    const dialogStyles = [
        styles.dialog,
        styles[colorMode],
        styles[surface.toLowerCase()],
    ];
    const overlayStyles = [
        styles.overlay,
        styles[colorMode],
        styles[surface.toLowerCase()],
    ];
    const tooltipButtonStyles = [
        styles.tooltipButton,
        styles[colorMode],
        styles[surface.toLowerCase()],
    ];
    const dialogWrapperStyles = [
        styles.dialogWrapper,
        styles[colorMode],
        styles[surface.toLowerCase()],
    ];
    const headingStyles = [styles.heading, styles[surface.toLowerCase()]];
    const bodyStyles = [styles.body, styles[surface.toLowerCase()]];
    const [expandedStateText, setExpandedStateText] = useState('expanded! ');
    if (unmounting) {
        dialogStyles.push(styles.unmounting);
        overlayStyles.push(styles.unmounting);
    }
    if (open) {
        dialogStyles.push(styles.open);
        overlayStyles.push(styles.open);
    }
    if (colorMode === 'light') {
        overlayStyles.push(styles.overlayLight);
        dialogStyles.push(styles.colorModeLight);
        tooltipButtonStyles.push(styles.buttonLight);
        dialogWrapperStyles.push(styles.wrapperLight);
    }
    if (colorMode === 'dark') {
        overlayStyles.push(styles.overlayDark);
        dialogStyles.push(styles.colorModeDark);
        tooltipButtonStyles.push(styles.buttonDark);
        dialogWrapperStyles.push(styles.wrapperDark);
    }
    /* istanbul ignore next -- @preserve */
    useEffect(() => {
        if (isAndroidDevice)
            OpenDialog();
        setTimeout(() => {
            setExpandedStateText('');
        }, 500);
        return () => {
            if (isAndroidDevice)
                CloseDialog();
        };
    }, [isAndroidDevice]);
    return (jsx(Portal, { id: dialogId, children: jsx("div", { className: styles.wrapper, children: jsx(FocusLock, { disabled: false, returnFocus: true, children: jsx("div", { className: overlayStyles.join(' '), onTouchEnd: onTouchEnd, onTouchStart: onTouchStart, onTouchMove: onTouchMove, children: jsxs("div", { className: dialogStyles.join(' '), children: [jsx("button", { className: tooltipButtonStyles.join(' '), onClick: onClick, "aria-label": `${expandedStateText}${closeButtonText}`, "data-testid": "mobile-dialog-close", children: closeButtonText }), jsx("div", { className: dialogWrapperStyles.join(' '), children: jsxs("div", { className: styles.contentContainer, children: [!!title && (jsx("span", { className: headingStyles.join(' '), children: title })), jsx("span", { className: bodyStyles.join(' '), children: body })] }) })] }) }) }) }) }));
};

export { MobileDialog as default };
